import { CpuChipIcon } from "@heroicons/react/16/solid";
import { useTranslation } from "react-i18next";
import Typewriter from "typewriter-effect";

const TypewriterLoading = () => {
  return (
    <div className="chat chat-start">
      <div className="chat-image avatar">
        <div className="hidden sm:w-10 sm:rounded-full">
          <CpuChipIcon />
        </div>
      </div>
      <div className="chat-bubble chat-bubble-neutral h-[38px] w-12 rounded-xl text-[14px] shadow-sm sm:h-[43px] sm:text-[16px]">
        <Typewriter
          onInit={(typewriter) => {
            typewriter
              .pauseFor(200)
              .typeString("...")
              .pauseFor(400)
              .deleteChars(3)
              .start();
          }}
          options={{
            delay: 70,
            deleteSpeed: 50,
            skipAddStyles: true,
            cursorClassName: "hidden",
            loop: true,
          }}
        />
      </div>
    </div>
  );
};

const TypewriterWelcome = () => {
  const { t } = useTranslation(["chatPage"]);
  return (
    <div className="mb-10 flex justify-center">
      <div className="text-center font-bold text-2xl ">
        <Typewriter
          onInit={(typewriter) => {
            typewriter.pauseFor(200).typeString(t("typewriterMessage")).start();
          }}
          options={{
            delay: 30,
            skipAddStyles: true,
            cursorClassName: "hidden",
          }}
        />
      </div>
    </div>
  );
};

export { TypewriterWelcome, TypewriterLoading };
